/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import Galaxy from 'solis/application/galaxy';

import Route from 'solis/route';
import Routes from 'solis/enum/route';

import DashboardRedirect from 'solis/claude/layout/dashboard.redirect';


const BOARD_ROUTES = [ Routes.DashboardBoard, Routes.DashboardInfluence, Routes.DashboardAttach ];


export default ({ children }) =>
{
  const route = use(Route);

  const galaxy = use(Galaxy);

  if (BOARD_ROUTES.includes(route.getType()) && galaxy.getBoard(route.getArg('id')) == null)
  {
    return <DashboardRedirect />;
  }

  return children;
};
